import { render } from "./elem-input-object.vue?vue&type=template&id=6a062d07&ts=true"
import script from "./elem-input-object.vue?vue&type=script&lang=ts"
export * from "./elem-input-object.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__